import React, { useState } from 'react';
import {
  Box,
  FormControl,
  FormLabel,
  Input,
  Button,
  Flex,
  Text,
  Spinner,
  useToast,
} from '@chakra-ui/react';
import { useHistory, useLocation } from 'react-router-dom';
import axios from 'axios';
import { motion } from 'framer-motion';
import toast from 'react-hot-toast';

const CreateCampaignForTemplate = () => {
  const [name, setName] = useState('');
  const [csvFile, setCsvFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const { templateId, templateName } = location.state || {};
  const history = useHistory();

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);

    const formData = new FormData();
    formData.append('name', name);
    formData.append('emailCsv', csvFile);
    formData.append('templateId', templateId);

    try {
      const res = await axios.post(
        'https://bounce.mailamp.in/campaign/html/create',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        },
      );
      toast.success('Campaign created successfully!');
    } catch (error) {
      console.error(error);
      const errorMessage = error.response?.data?.message || 'An error occurred';
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <motion.div
      initial={{ scale: 0.5, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{
        type: 'spring',
        stiffness: 120,
        damping: 10,
        duration: 0.5,
      }}
    >
      <Flex justify="center" align="center" h="100vh" bg="#f6f3fc">
        <Box
          w="100%"
          maxW="2xl"
          px="6"
          py="8"
          bg="white"
          boxShadow="lg"
          rounded="lg"
        >
          <Text fontSize="2xl" mb="4">
            Create Campaign for Template {templateName}
          </Text>
          <form onSubmit={handleSubmit}>
            <FormControl isRequired>
              <FormLabel>Name</FormLabel>
              <Input
                placeholder="Enter your campaign name"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </FormControl>

            <FormControl mt="4" isRequired>
              <FormLabel>Upload CSV file</FormLabel>
              <Input
                type="file"
                accept=".csv"
                onChange={(e) => setCsvFile(e.target.files[0])}
              />
            </FormControl>

            <Flex justify="center">
              <Button
                variant="brand"
                w="100%"
                mt="6"
                type="submit"
                isLoading={loading}
                isDisabled={loading}
                loadingText="Please wait..."
                spinner={<Spinner size="sm" />}
              >
                Create
              </Button>
            </Flex>
          </form>
        </Box>
      </Flex>
    </motion.div>
  );
};

export default CreateCampaignForTemplate;
